import { Navigate, Route, Routes } from 'react-router-dom'
import ResetPage from './pages/ResetPage'
import InvalidLinkPage from './pages/InvalidLinkPage'

/**
 * Router.
 *
 * - `/reset`  primary reset flow (reads ?token=).
 * - `/`       redirect to /reset (a bare visit is treated as a reset attempt
 *             with no token, which lands on the friendly invalid-link screen).
 * - `*`       catch-all -> friendly invalid-link screen.
 */
export default function App() {
  return (
    <Routes>
      <Route path="/reset" element={<ResetPage />} />
      <Route path="/" element={<Navigate to="/reset" replace />} />
      <Route path="*" element={<InvalidLinkPage />} />
    </Routes>
  )
}
